export const ADMIN_LEVEL_TWO_RESET_STATE = 'ADMIN_LEVEL_TWO_RESET_STATE';
export const ADMIN_LEVEL_TWO_CURRENT_ITEM = 'ADMIN_LEVEL_TWO_CURRENT_ITEM';

export const ADMIN_LEVEL_TWO_REQUEST_LOADING = 'ADMIN_LEVEL_TWO_REQUEST_LOADING';
export const ADMIN_LEVEL_TWO_REQUEST_SUCCESS = 'ADMIN_LEVEL_TWO_REQUEST_SUCCESS';
export const ADMIN_LEVEL_TWO_REQUEST_FAILED = 'ADMIN_LEVEL_TWO_REQUEST_FAILED';

export const ADMIN_LEVEL_TWO_CURRENT_ACTION = 'ADMIN_LEVEL_TWO_CURRENT_ACTION';
export const ADMIN_LEVEL_TWO_RESET_ACTION = 'ADMIN_LEVEL_TWO_RESET_ACTION';